(function () {
  if (window.__mcSliderProgressInitialized) return;
  window.__mcSliderProgressInitialized = true;

  var SECTION_SELECTOR = '[data-section-type="multi-column"]';
  var INITIALIZED_ATTR = 'mcSliderInitialized';
  var cleanupMap = new WeakMap();

  var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
  };

  var initializeSection = function (section) {
    if (!section || section.dataset[INITIALIZED_ATTR] === 'true') return;

    var track = section.querySelector('[data-mc-slider-track]');
    if (!track) return;

    var progressBar = section.querySelector('[data-mc-slider-progress]');
    if (!progressBar) return;

    section.dataset[INITIALIZED_ATTR] = 'true';

    var buttonPrev = section.querySelector('[data-scent-carousel-prev]');
    var buttonNext = section.querySelector('[data-scent-carousel-next]');
    var progressTrack = progressBar.parentElement;
    var resizeObserver = null;
    var progressIndicatorWidth = 0;
    var maxScroll = 0;

    var listeners = [];
    var addListener = function (target, event, handler, options) {
      if (!target) return;
      target.addEventListener(event, handler, options || false);
      listeners.push(function () {
        target.removeEventListener(event, handler, options || false);
      });
    };

    var getScentCarouselGap = function () {
      var styles = window.getComputedStyle(track);
      var gapValue = styles.columnGap || styles.gap || '0';
      var parsed = parseFloat(gapValue);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    var getScentCarouselItemSpan = function () {
      var firstItem = track.querySelector('.multi-column__grid-item');
      if (!firstItem) {
        return 0;
      }
      return firstItem.getBoundingClientRect().width + getScentCarouselGap();
    };

    var updateProgressPosition = function () {
      if (!progressTrack) return;
      var trackWidth = progressTrack.offsetWidth;
      if (!trackWidth) {
        progressBar.style.transform = 'translateX(0)';
        return;
      }
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var maxOffset = Math.max(trackWidth - progressIndicatorWidth, 0);
      var offset = maxOffset * clamp(ratio, 0, 1);
      progressBar.style.transform = 'translateX(' + offset.toFixed(2) + 'px)';
    };

    var updateProgressMetrics = function () {
      if (!progressTrack) return;
      var trackWidth = progressTrack.offsetWidth;
      if (!trackWidth) {
        progressIndicatorWidth = 0;
        progressBar.style.width = '0px';
        progressBar.style.transform = 'translateX(0)';
        return;
      }
      if (maxScroll <= 0) {
        progressIndicatorWidth = trackWidth;
      } else {
        var desiredWidth = 132;
        progressIndicatorWidth = Math.min(trackWidth, desiredWidth);
      }
      progressBar.style.width = progressIndicatorWidth.toFixed(2) + 'px';
      updateProgressPosition();
    };

    var updateScentCarouselUI = function () {
      updateProgressPosition();
      if (buttonPrev) {
        buttonPrev.disabled = track.scrollLeft <= 1;
      }
      if (buttonNext) {
        buttonNext.disabled = maxScroll - track.scrollLeft <= 1;
      }
    };

    var updateMetrics = function () {
      maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      updateProgressMetrics();
      updateScentCarouselUI();
    };

    var scrollScentCarouselByStep = function (direction) {
      var distance = getScentCarouselItemSpan();
      if (!distance) {
        return;
      }
      track.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    };

    addListener(track, 'scroll', function () {
      updateProgressPosition();
      updateScentCarouselUI();
    }, { passive: true });

    var handleClickPrev = function () {
      scrollScentCarouselByStep(-1);
    };
    var handleClickNext = function () {
      scrollScentCarouselByStep(1);
    };
    addListener(buttonPrev, 'click', handleClickPrev);
    addListener(buttonNext, 'click', handleClickNext);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        updateMetrics();
      });
      resizeObserver.observe(track);
    } else {
      var resizeHandler = function () { updateMetrics(); };
      window.addEventListener('resize', resizeHandler);
      listeners.push(function () {
        window.removeEventListener('resize', resizeHandler);
      });
    }

    updateMetrics();

    cleanupMap.set(section, function () {
      listeners.forEach(function (fn) { fn(); });
      listeners = [];
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      delete section.dataset[INITIALIZED_ATTR];
      cleanupMap.delete(section);
    });
  };

  var initAll = function (root) {
    var sections = (root || document).querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initializeSection(sections[i]);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = null;
    if (event && event.detail && event.detail.sectionId) {
      var wrapper = document.getElementById('shopify-section-' + event.detail.sectionId);
      if (wrapper) section = wrapper.querySelector(SECTION_SELECTOR);
    }
    if (!section && event && event.target) {
      section = event.target.matches && event.target.matches(SECTION_SELECTOR)
        ? event.target
        : event.target.querySelector(SECTION_SELECTOR);
    }
    if (section) {
      var cleanup = cleanupMap.get(section);
      if (cleanup) cleanup();
    }
  });
})();
